
export const getDashboardJson = (state: any) => state.dashboard;
